import Button from "@mui/material/Button";
import PropTypes from "prop-types";

import ArrowLeft from "~/components/Icon/ArrowLeftIcon";
import ArrowRight from "~/components/Icon/ArrowRightIcon";
import { styled } from "@mui/material/styles";

const PagerButton = styled(Button)(props => ({
  zIndex: 1000,
  width: "64px",
  height: "128px",
  position: "absolute",
  top: "50%",
  bottom: "0",
  transform: "translateY(-50%)",
  [props.direction]: 0,
  padding: 0,
  "&:focus-visible": {
    outline: props.theme.outline(),
    outlineOffset: "-2px",
    zIndex: 10000
  }
}));

const Background = styled("div")(props => ({
  zIndex: 1001,
  backgroundColor: "#404040",
  backgroundImage: "url(/static/images/texture.png)",
  opacity: 0.7,
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
}));

const ArrowLeftIcon = styled(ArrowLeft)(props => ({
  zIndex: 1002,
  cursor: "pointer",
  width: "64px",
  height: "128px",
  color: "#ffffff"
}));

const ArrowRightIcon = styled(ArrowRight)(props => ({
  zIndex: 1002,
  cursor: "pointer",
  width: "64px",
  height: "128px",
  color: "#ffffff"
}));

function Pager({ direction, onClick }) {
  return (
    <PagerButton className="pager" direction={direction} onClick={onClick}>
      <Background />
      {direction === "left" ? <ArrowLeftIcon /> : <ArrowRightIcon />}
    </PagerButton>
  );
}

Pager.propTypes = {
  onClick: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(["left", "right"]).isRequired
};

export default Pager;
